/**
*
*   Featured Products
*       - The featured products collection on the home page
*
**/
import Button from '@/components/button';
import Image from '@/components/image';
import { Link } from '@/components/link';
import { useLocale } from 'next-intl';

//Build the Element
export default function Advertisement({ ...props }){

	//Skip advertisement
	return false;

	//
	const locale = useLocale();

	const content = {
		link:       '/collections/all',
		image:      'advertisements/canada-day-sale-2026.png',
		en: {
			header:     'Canada Day Sale',
			subheader:  'Get up to 25% off site wide',
			content:    'Celebrate Canada with up to 25% off site wide',
			alt:        'Canada Day Sale: up to 25% off site wide',
			button:     'Shop Now'
		},
		fr: {
			header:     'Vente de la fête du Canada',
			subheader:  'Jusqu’à 25 % de rabais sur tout le site',
			content:    'Célébrez le Canada avec jusqu’à 25 % de rabais sur tout le site',
			alt:        'Vente de la fête du Canada : jusqu’à 25 % de rabais sur tout le site',
			button:     'Afficher maintenant'
		}
	};

	//Skip the link if there is no link available
	const Linkable = ({ href , children }) => {
		if( href ) return <Link href={ href }>{ children }</Link>;
		return children;
	};

	//Return
	return (
		<section className="advertisement">
			<Linkable href={ content?.link }>
				<Image src={ content.image } width="890" height="890" alt={ content[ locale ]?.alt } />
			</Linkable>
			<div className="details">
				<h3>{ content[ locale ]?.header }</h3>
				<p className="inci">{ content[ locale ]?.subheader }</p>
				<p>{ content[ locale ]?.content }</p>
				{ content?.link && (
					<Button href={ content.link } size="narrow">{ content[ locale ]?.button }</Button>
				)}
			</div>
		</section>
	);

}